import React from 'react';
import { useSelector } from 'react-redux';
import { DotsLoader, TextLink } from '@drone-js/core';
import { selectCmsFromBootstrap } from 'store/slice/bootstrap';

interface OwnProps {
    onClick: () => void;
    isLoading: boolean;
    isTranslated: boolean;
    isDisabled: boolean;
    index: number;
}

type Props = OwnProps;

const ReviewsTranslateButton: React.FC<Props> = (props) => {
    const cms = useSelector(selectCmsFromBootstrap);
    if (props.isTranslated) {
        return null;
    }

    if (props.isLoading) {
        // Forced inline style on div because DotsLoader does not respect margin without it
        return (
            <div style={{ display: 'inline-block' }}>
                <DotsLoader label={cms[326495]} variant="primary" mt="8" mb="8" />
            </div>
        );
    }

    return (
        <TextLink
            hierarchy={props.isDisabled ? 'secondary' : 'primary'}
            label={cms[68629]}
            onClick={props.onClick}
            disabled={props.isDisabled}
            leadingIcon="fill.symbol.bubble-language"
            data-element-name="activities-review-translate-button"
            data-testid="activities-review-translate-button"
            data-element-index={props.index + 1}
        />
    );
};
ReviewsTranslateButton.displayName = 'ReviewsTranslateButton';
export default ReviewsTranslateButton;
